import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import EmailName from 'automation-ui-references/customer-data/EmailName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ClassicNotificationEmailActionExplainer({
  action,
  flowObjectTypeId
}) {
  const {
    emailContentId,
    recipientEmails,
    recipientProperty
  } = action.metadata;
  const recipientList = (recipientEmails || []).map(email => /*#__PURE__*/_jsx("strong", {
    children: email
  }, email)).concat(recipientProperty ? [/*#__PURE__*/_jsx(PropertyName, {
    propertyName: recipientProperty,
    objectTypeId: flowObjectTypeId
  }, recipientProperty)] : []);
  const recipients = recipientList.length > 0 ? /*#__PURE__*/_jsx(FormattedList, {
    children: recipientList
  }) : /*#__PURE__*/_jsx(MissingLabel, {
    type: "recipient"
  });
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.classic-notification-email.explainer",
    options: {
      emailName: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(EmailName, {
          id: emailContentId
        })
      }),
      recipients
    }
  });
}